import {useEffect, useState} from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from "@mui/material";
import useGatePass from "../hooks/useGatePass";

const EntryTypeDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled} = props;

    const theme = useTheme();

    const {isFetchingEntryType, entryTypeList, getGatePassEntryType} = useGatePass();
    const [entryTypesData, setEntryTypesData] = useState([]);

    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");
    

    useEffect(() => {
        getGatePassEntryType();
    }, [])

    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");

        if (entryTypeList?.length > 0) {
            const filteredEntryTypes = entryTypeList?.filter((type) => type !== value);

            setEntryTypesData(filteredEntryTypes);
        }
    }, [entryTypeList, value])
    

    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }


    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={entryTypesData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                loading={isFetchingEntryType}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Entry Type not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select entry type"
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {(isFetchingEntryType) ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default EntryTypeDropdownComponent